import { render, staticRenderFns } from "./CategoriesLogs.vue?vue&type=template&id=d3667194"
import script from "./CategoriesLogs.vue?vue&type=script&lang=js"
export * from "./CategoriesLogs.vue?vue&type=script&lang=js"
import style0 from "./CategoriesLogs.vue?vue&type=style&index=0&id=d3667194&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports